import React from 'react';
import SAInputComponent from "./SAInputComponent";
import SASlider from "./SASlider";

class SAInputPercentageLabel extends React.Component {

  render() {
    const {label, value, onChange, error, ...attributes} = this.props;

    return (
      <SAInputComponent label={label}>
        <SASlider value={value} onChange={onChange}
                  min={0} max={100} step={10}  tipFormatter={(v) => `${v}%`}
                  marks={{0: '0', 50: '50', 100: '100'}} error={error} {...attributes}/>
      </SAInputComponent>
    )
  }
}

export default SAInputPercentageLabel;
